"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const test_utils_1 = require("react-dom/test-utils");
const test_utils_2 = __importDefault(require("react-dom/test-utils"));
// simulate events for both polaris and regular elements
const buildEventSimulator = (event) => (wrapper) => test_utils_1.act(() => {
    const element = wrapper.getElement();
    // polaris element
    if (element.constructor.name === 'HTMLUnknownElement') {
        wrapper[event]();
    }
    else {
        // regular element
        test_utils_2.default.Simulate[event](element);
    }
});
exports.Click = buildEventSimulator('click');
//# sourceMappingURL=Events.js.map